import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import { useTimeZoneList } from './hooks';
import styled from '@emotion/styled';
import { fontSize, fontWeight, spacing } from 'presentations/views/styles';
import Popover from 'presentations/views/components/atoms/Popover';
import TextField from 'presentations/views/components/atoms/TextField';
import {
  gray01,
  gray05,
  gray06,
  white,
} from 'presentations/views/styles/color';
import { PopoverOrigin } from '@mui/material';

interface Props {
  onSelect: (name: string) => void;
  onClose: (name: string) => void;
  anchor: HTMLElement;
  title: string;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
}

export default function Component(props: Props) {
  const { state, actions } = useTimeZoneList(props);
  const t = translateInComponent([translations]);

  if (state.isLoading) return null;
  return (
    <Popover
      anchor={props.anchor}
      anchorOrigin={
        props.anchorOrigin || {
          vertical: 'bottom',
          horizontal: 'right',
        }
      }
      transformOrigin={
        props.transformOrigin || {
          vertical: 'top',
          horizontal: 'left',
        }
      }
      onClose={props.onClose}
      maxHeight={400}
      isKeepMounted={false}
    >
      <Container>
        <Header>
          <SectionTitle>{props.title}</SectionTitle>
          <TextField
            onChange={actions.onChangeQuery}
            size="small"
            isFullWidth
            variant="outlined"
            isAutoFocus
            placeholder={t('placeholder', { tz: state.placeholder })}
          />
        </Header>
        <Content>
          {state.timeZones.map((timeZone, index) => (
            <MenuListItem
              key={index}
              data-id={index}
              onClick={actions.onSelect}
            >
              <Offset>{timeZone.offsetText}</Offset>
              <Name>
                <ZoneName>{timeZone.timeName}</ZoneName>
                <Long>{timeZone.offsetNameLong}</Long>
              </Name>
            </MenuListItem>
          ))}
        </Content>
      </Container>
    </Popover>
  );
}

const Header = styled.div`
  padding: ${spacing(16)} ${spacing(16)} ${spacing(8)};
  background-color: ${white};
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
`;
const Container = styled.div`
  min-width: 300px;
`;
const Content = styled.div`
  padding-bottom: ${spacing(8)};
`;
const MenuListItem = styled.div`
  display: flex;
  padding: ${spacing(8)} ${spacing(16)};
  cursor: pointer;
  :hover {
    background-color: ${gray05};
  }
`;
const Offset = styled.div`
  color: ${gray01};
  font-size: ${fontSize(12)};
  margin-right: ${spacing(8)};
  min-width: 56px;
`;
const Name = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${fontSize(16)};
`;
const ZoneName = styled.div`
  line-height: 1;
`;
const Long = styled.div`
  color: ${gray01};
  font-size: ${fontSize(11)};
  margin-top: ${spacing(2)};
`;
const SectionTitle = styled.div`
  font-size: ${fontSize(14)};
  font-weight: ${fontWeight('bold')};
  margin-bottom: ${spacing(8)};
  display: flex;
  align-items: center;
`;
